// extracted by mini-css-extract-plugin
export default {"block-tab-content":"mzLm3ZKpsHc0N8q","block-title":"dlsTxGavV8Ph0LE","block":"OaPpruPIb80nYow","block-content":"dlln4C9MGVO3NWc"};